"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AggregateBase = void 0;
var _featureBase = require("./feature-base");
var _info = require("../../common/config/info");
var _runtime = require("../../common/config/runtime");
var _configure = require("../../loaders/configure/configure");
var _nreum = require("../../common/window/nreum");
var _drain = require("../../common/drain/drain");
var _featureFlags = require("../../common/util/feature-flags");
var _obfuscate = require("../../common/util/obfuscate");
class AggregateBase extends _featureBase.FeatureBase {
  constructor(...args) {
    super(...args);
    this.checkConfiguration();
    this.obfuscator = (0, _runtime.getRuntime)(this.agentIdentifier).obfuscator;
  }

  /**
   * New handler for waiting for multiple flags. Useful when expecting multiple flags simultaneously (ex. stn vs sr)
   * @param {string[]} flagNames
   * @returns {Promise}
   */
  waitForFlags(flagNames = []) {
    const flagsPromise = new Promise((resolve, reject) => {
      if (_featureFlags.activatedFeatures[this.agentIdentifier]) {
        resolve(buildOutput(_featureFlags.activatedFeatures[this.agentIdentifier]));
      } else {
        this.ee.on('rumresp', (resp = {}) => {
          resolve(buildOutput(resp));
        });
      }
      function buildOutput(ref) {
        return flagNames.map(flag => {
          if (!ref[flag]) return 0;
          return ref[flag];
        });
      }
    });
    return flagsPromise.catch(err => {
      this.ee.emit('internal-error', [err]);
      this.blocked = true;
      (0, _drain.deregisterDrain)(this.agentIdentifier, this.featureName);
    });
  }
  drain() {
    (0, _drain.drain)(this.agentIdentifier, this.featureName);
    this.drained = true;
  }

  /**
   * Checks for additional `jsAttributes` items to support backward compatibility with implementations of the agent where
   * loader configurations may appear after the loader code is executed.
   */
  checkConfiguration() {
    // NOTE: This check has to happen at aggregator load time
    if (!(0, _info.isValid)(this.agentIdentifier)) {
      const cdn = (0, _nreum.gosCDN)();
      let jsAttributes = {
        ...cdn.info?.jsAttributes
      };
      try {
        jsAttributes = {
          ...jsAttributes,
          ...(0, _info.getInfo)(this.agentIdentifier)?.jsAttributes
        };
      } catch (err) {
        // do nothing
      }
      (0, _configure.configure)({
        agentIdentifier: this.agentIdentifier
      }, {
        ...cdn,
        info: {
          ...cdn.info,
          jsAttributes
        },
        runtime: (0, _runtime.getRuntime)(this.agentIdentifier)
      });
    }
    const runtime = (0, _runtime.getRuntime)(this.agentIdentifier);
    if (!runtime.obfuscator) {
      runtime.obfuscator = new _obfuscate.Obfuscator(this.agentIdentifier);
    }
  }
}
exports.AggregateBase = AggregateBase;